"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformHeatmapsToHeatmapsOutput = void 0;
function transformHeatmapsToHeatmapsOutput(heatmaps) {
    const output = [];
    for (const heatmap of heatmaps) {
        const originChunk = {
            movementLocation: heatmap.originLocationId,
            latitude: heatmap.originLocationPosition.latitude,
            longitude: heatmap.originLocationPosition.longitude,
            departureAt1: heatmap.departureAt1,
        };
        const destinationChunk = {
            movementLocation: heatmap.destinationLocationId,
            latitude: heatmap.destinationLocationPosition.latitude,
            longitude: heatmap.destinationLocationPosition.longitude,
            departureAt1: heatmap.departureAt1,
        };
        for (const vehicleType of heatmap.vehicleIds) {
            output.push({ ...originChunk, vehicle: vehicleType });
            output.push({ ...destinationChunk, vehicle: vehicleType });
        }
    }
    return output;
}
exports.transformHeatmapsToHeatmapsOutput = transformHeatmapsToHeatmapsOutput;
//# sourceMappingURL=transformHeatmapsToHeatmapsOutput.js.map